import { render, staticRenderFns } from "./submitContract.vue?vue&type=template&id=23148608&scoped=true"
import script from "./submitContract.vue?vue&type=script&lang=js"
export * from "./submitContract.vue?vue&type=script&lang=js"
import style0 from "./submitContract.vue?vue&type=style&index=0&id=23148608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23148608",
  null
  
)

export default component.exports